$shm_date_view $mol_date
	value_min \
	value_max \
	Input $shm_date_input
		value? <=> input_value? \
		value_changed? => value_changed?
		submit? <=> input_commit? null
		mask* <= input_mask* \
		enabled <= enabled true
		event *
			^
			blur? <=> input_commit? null
	Calendar $shm_date_calendar
		enabled <= enabled true
		month_moment <= month_moment <= value_moment
		day_selected* <= day_selected* false
		day_enabled* <= day_enabled* false
		day_click*? <=> day_click*? null
		Title => Calendar_title
		head /
			<= Calendar_tools $mol_view
				sub /
					<= Prev $mol_button_minor
						hint <= prev_hint @ \Previous month
						enabled <= prev_enabled true
						click? <=> prev? null
						sub /
							<= Prev_icon $mol_icon_chevron_left
					<= Calendar_title
					<= Next $mol_button_minor
						hint <= next_hint @ \Next month
						enabled <= next_enabled true
						click? <=> next? null
						sub /
							<= Next_icon $mol_icon_chevron_right

$shm_date_input $mol_format

$shm_date_calendar $mol_date_calendar
	day_enabled* true
	day_content* /
		<= Day_button* $mol_button_minor
			title <= day_text*
			attr *
				^
				mol_calendar_today <= day_today*
				mol_theme <= day_theme* null
				shm_date_selected <= day_selected* false
			event_click? <=> day_click*? null
			minimal_height 24
			enabled <= day_enabled* true
